module.exports = __webpack_public_path__ + "img/explore_honglou.629325a5.png";